import { c as _c } from "react/compiler-runtime";
import Div100vh from "react-div-100vh";
import ReactDOM from "react-dom";
import Button from "../Button";
import styles from "./styles.module.scss";
import { JSX, useEffect, useState } from "react";
import Close from "../Icons/Close";
import { lockBodyScroll, unlockBodyScroll } from "@/utils/modalLock";
export interface ModalPropsType {
  onAccept?: () => void;
  onDecline?: () => void;
  onClose?: () => void;
  content: {
    title?: string;
    subTitle?: string;
    description?: string;
    accept?: string;
    decline?: string;
  };
  display: boolean;
  acceptLoading?: boolean;
  showCloseIcon?: boolean;
}
function Modal(t0) {
  const $ = _c(50);
  const {
    onAccept,
    onDecline,
    onClose,
    content,
    display: t1,
    acceptLoading,
    showCloseIcon: t2
  } = t0;
  const display = t1 === undefined ? false : t1;
  const showCloseIcon = t2 === undefined ? true : t2;
  const [isBrowser, setIsBrowser] = useState(false);
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setIsBrowser(true);
    };
    t4 = [];
    $[0] = t3;
    $[1] = t4;
  } else {
    t3 = $[0];
    t4 = $[1];
  }
  useEffect(t3, t4);
  let t5;
  let t6;
  if ($[2] !== display) {
    t5 = () => {
      if (display) {
        lockBodyScroll();
        return _temp;
      }
    };
    t6 = [display];
    $[2] = display;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  let t7;
  if ($[5] !== onAccept) {
    t7 = () => onAccept?.();
    $[5] = onAccept;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const handleAcceptClick = t7;
  let t8;
  if ($[7] !== onDecline) {
    t8 = () => onDecline?.();
    $[7] = onDecline;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const handleDeclineClick = t8;
  let t9;
  if ($[9] !== onClose) {
    t9 = () => onClose?.();
    $[9] = onClose;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  const handleCloseClick = t9;
  if (isBrowser && display) {
    let t10;
    if ($[11] !== acceptLoading || $[12] !== content.accept || $[13] !== content.decline || $[14] !== content.description || $[15] !== content.subTitle || $[16] !== content.title || $[17] !== handleAcceptClick || $[18] !== handleCloseClick || $[19] !== handleDeclineClick || $[20] !== showCloseIcon) {
      let t11;
      if ($[22] !== handleCloseClick || $[23] !== showCloseIcon) {
        t11 = showCloseIcon && <div className={styles.closeIconWrapper}><button tabIndex={0} data-testid="modal-close-icon" className={styles.btnIconClose} onClick={handleCloseClick}><Close /></button></div>;
        $[22] = handleCloseClick;
        $[23] = showCloseIcon;
        $[24] = t11;
      } else {
        t11 = $[24];
      }
      let t12;
      if ($[25] !== content.title) {
        t12 = content.title && <h2 className={styles.title}>{content.title}</h2>;
        $[25] = content.title;
        $[26] = t12;
      } else {
        t12 = $[26];
      }
      let t13;
      if ($[27] !== content.subTitle) {
        t13 = content.subTitle && <h4 className={styles.subTitle}>{content.subTitle}</h4>;
        $[27] = content.subTitle;
        $[28] = t13;
      } else {
        t13 = $[28];
      }
      const t14 = content?.description;
      let t15;
      if ($[29] !== t14) {
        t15 = <p className={styles.description}>{t14}</p>;
        $[29] = t14;
        $[30] = t15;
      } else {
        t15 = $[30];
      }
      let t16;
      if ($[31] !== t12 || $[32] !== t13 || $[33] !== t15) {
        t16 = <div>{t12}{t13}{t15}</div>;
        $[31] = t12;
        $[32] = t13;
        $[33] = t15;
        $[34] = t16;
      } else {
        t16 = $[34];
      }
      let t17;
      if ($[35] !== acceptLoading || $[36] !== content.accept || $[37] !== handleAcceptClick) {
        t17 = content.accept && <Button color="primary" className="w-full" isLoading={acceptLoading} data-testid="modal-accept-button" onClick={handleAcceptClick}>{content.accept}</Button>;
        $[35] = acceptLoading;
        $[36] = content.accept;
        $[37] = handleAcceptClick;
        $[38] = t17;
      } else {
        t17 = $[38];
      }
      let t18;
      if ($[39] !== content.decline || $[40] !== handleDeclineClick) {
        t18 = content.decline && <Button color="nocolor" className="w-full" onClick={handleDeclineClick}>{content.decline}</Button>;
        $[39] = content.decline;
        $[40] = handleDeclineClick;
        $[41] = t18;
      } else {
        t18 = $[41];
      }
      let t19;
      if ($[42] !== t11 || $[43] !== t16 || $[44] !== t17 || $[45] !== t18) {
        t19 = <div className={styles.modal} onClick={_temp2}><div className={styles.content}>{t11}{t16}{t17}{t18}</div></div>;
        $[42] = t11;
        $[43] = t16;
        $[44] = t17;
        $[45] = t18;
        $[46] = t19;
      } else {
        t19 = $[46];
      }
      let t20;
      if ($[47] !== handleCloseClick || $[48] !== t19) {
        t20 = <Div100vh data-testid="modal-wrapper" className={styles.wrapper} onClick={handleCloseClick}>{t19}</Div100vh>;
        $[47] = handleCloseClick;
        $[48] = t19;
        $[49] = t20;
      } else {
        t20 = $[49];
      }
      t10 = ReactDOM.createPortal(t20, document.getElementById("modal-root") as HTMLElement);
      $[11] = acceptLoading;
      $[12] = content.accept;
      $[13] = content.decline;
      $[14] = content.description;
      $[15] = content.subTitle;
      $[16] = content.title;
      $[17] = handleAcceptClick;
      $[18] = handleCloseClick;
      $[19] = handleDeclineClick;
      $[20] = showCloseIcon;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    return t10;
  }
  return null;
}
function _temp2(e) {
  e.stopPropagation();
}
function _temp() {
  return unlockBodyScroll();
}
export default Modal;